import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { PaidTask } from "../../../types/PaidTask";
import ExternalPaidTaskTableRow from "./ExternalPaidTaskTableRow";
import { PAID_TASK_STATUS_APPROVED, PAID_TASK_STATUS_ASSIGNED, PAID_TASK_STATUS_IN_PRE_REVIEW, PAID_TASK_STATUS_CREATED } from "../paidTaskStatus";
import { paidTaskTableStyle } from "./paidTaskTableStyle";
import Typography from "@mui/material/Typography";
import { TableComponents, TableVirtuoso } from "react-virtuoso";
import dayjs from "dayjs";

type ExternalPaidTaskTableProps = {
  paidTasks: PaidTask[];
  isMinimalView?: boolean;
  isRequestedView?: boolean;
  noPaidTasksText?: string;
};

const getPaidTaskStyle = (paidTask: PaidTask) => {
  if (paidTask.status >= PAID_TASK_STATUS_APPROVED) {
    return paidTaskTableStyle.done;
  }

  if (paidTask.status === PAID_TASK_STATUS_CREATED && dayjs().isAfter(paidTask.assignmentDeadline, "day")) {
    return paidTaskTableStyle.overdue;
  }

  if ([PAID_TASK_STATUS_ASSIGNED, PAID_TASK_STATUS_IN_PRE_REVIEW].includes(paidTask.status) && dayjs().isAfter(paidTask.doneDeadline, "day")) {
    return paidTaskTableStyle.overdue;
  }
};

const ExternalPaidTaskTable = ({
  paidTasks,
  isMinimalView = false,
  isRequestedView = false,
  noPaidTasksText = "Keine Aufgaben",
}: ExternalPaidTaskTableProps) => {
  function rowContent(_index: number, paidTask: PaidTask) {
    return (
      <ExternalPaidTaskTableRow
        key={_index}
        paidTask={paidTask}
        isMinimalView={isMinimalView}
        isRequestedView={isRequestedView}
      />
    );
  }

  function fixedHeaderContent() {
    return (
      <TableRow
        sx={{
          backgroundColor: "background.paper",
        }}
      >
        <TableCell width={"70px"} />
        <TableCell>Fall</TableCell>
        <TableCell>Rechtsprodukt</TableCell>
        <TableCell>Aufgabe</TableCell>
        {!isMinimalView && <TableCell>Honorar</TableCell>}
        {isRequestedView && <TableCell>Annahme bis</TableCell>}
        <TableCell>Erledigung bis</TableCell>
        <TableCell />
      </TableRow>
    );
  }

  if (paidTasks.length === 0) {
    return (
      <Box style={{ padding: 30 }}>
        <Typography sx={{
          textAlign: "center"
        }}>{noPaidTasksText}</Typography>
      </Box>
    );
  }

  const VirtuosoTableComponents: TableComponents<PaidTask> = {
    Scroller: React.forwardRef<HTMLDivElement>((props, ref) => <TableContainer {...props} ref={ref} />),
    Table: (props) => <Table {...props} sx={{ borderCollapse: "separate", tableLayout: "fixed" }} />,
    TableHead: React.forwardRef<HTMLTableSectionElement>((props, ref) => {
      return <TableHead {...props} ref={ref} />;
    }),
    TableRow: ({ item: paidTask, ...props }) => <TableRow sx={getPaidTaskStyle(paidTask)} {...props} />,
    TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => <TableBody {...props} ref={ref} />),
  };

  return (
    <Box style={{ height: "50vh" }}>
      <TableVirtuoso
        data={paidTasks}
        components={VirtuosoTableComponents}
        fixedHeaderContent={fixedHeaderContent}
        itemContent={rowContent}
      />
    </Box>
  );
};
export default ExternalPaidTaskTable;
